<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryContacts.Title' | translate}}</h2>
  </div>
</div>

  <div class="row " >

  <!--País-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('countryCode') || personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido()">
        <label for="countryCode"  [class.disabled]=" isFieldDisabled('countryCode') || personTypologyCode!=personTypesValues.Singular  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(personTypologyCode!=personTypesValues.Singular  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Country' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.countryCode" name="countryCode" #countryCode="ngModel"
                [required]="!(personTypologyCode!=personTypesValues.Singular  || isNotStateRLDiferido())"
                [clearRelated]="{model : this.cardData , propsToReset : ['postalCode','locality','postalDesignation','telephone']} "
                [dropdownTitle]="{value : cardData.countryCode, dimensions :  countries }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of countries" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="countryCode"></validation-message>
      </fieldset>
    </div>
  </div>

  <!--Morada-->
  <div class="col-sm-8">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('address') || personTypologyCode!=personTypesValues.Singular  || isNotStateRLDiferido()">
        <label for="address" [class.disabled]=" isFieldDisabled('address') || personTypologyCode!=personTypesValues.Singular  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(personTypologyCode!=personTypesValues.Singular  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Address' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="cardData.address"
                 [required]="!(personTypologyCode!=personTypesValues.Singular  || isNotStateRLDiferido())"
                  maxlength="80"
                 #address="ngModel" name="address"
                 messageFieldType="string" style='text-transform:uppercase'>

          <validation-message [control]="address"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

</div>

<div class="row ">

  <!--Código Postal-->
  <div class="col-sm-4" *ngIf="cardData.countryCode==null || cardData.countryCode==null || cardData.countryCode=='PT'">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('postalCodeFirst') || personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido()">
        <label for="postalCodeFirst" [class.disabled]=" isFieldDisabled('postalCodeFirst') || personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido())">*</span>
          {{'CardSubscriberContacts.PostalCode' | translate}}
        </label>
        <div class="form-row">
          <div class="col-sm-6">
            <input class="form-control" type="text" numeric="4" placeholder="{{'Placeholders.Generic.PostalCodeFirst4' | translate}}"
                   [(ngModel)]="cardData.postalCodeFirst" name="postalCodeFirst"
                   #postalCodeFirst="ngModel"
                   [exactLength]="personTypologyCode==personTypesValues.Singular?4:0" pattern="\d*"
                   [required]="!(personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido())"
                   (ngModelChange)="onPostalCodeChanged()">
            <validation-message [control]="postalCodeFirst"></validation-message>
          </div>
          <div class="col-sm-6">
            <input class="form-control" type="text" numeric="3" placeholder="{{'Placeholders.Generic.PostalCodeLast3' | translate}}"
                   [(ngModel)]="cardData.postalCodeLast" name="postalCodeLast"
                   #postalCodeLast="ngModel"
                   [exactLength]="personTypologyCode==personTypesValues.Singular?3:0" pattern="\d*"
                   [required]="!(personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido())"
                   (ngModelChange)="onPostalCodeChanged()">
            <validation-message [control]="postalCodeLast"></validation-message>
          </div>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Código Postal FULL-->
  <div class="col-sm-4" *ngIf="cardData.countryCode!=null && cardData.countryCode!=undefined && cardData.countryCode!='PT'">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('postalCodeFull') || personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido()">
        <label for="postalCodeFull"  [class.disabled]=" isFieldDisabled('postalCodeFull') || personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido())">*</span>
          {{'CardSubscriberContacts.PostalCode' | translate}}
        </label>
          <input class="form-control" type="text" numeric="20" 
                  [(ngModel)]="cardData.postalCodeFull" name="postalCodeFull"
                  #postalCodeFirst="ngModel" 
                    [required]="!(personTypologyCode!=personTypesValues.Singular || isNotStateRLDiferido())">
          <validation-message [control]="postalCodeFull"></validation-message>
      </fieldset>
    </div>
  </div>


  <!--Designação postal-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="postalDesignation" class="disabled">
        {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.PostalDesignation' | translate}}
      </label>
      <div class="position-relative">
        <input class="form-control input-right" type="text" [(ngModel)]="cardData.postalDesignation"
               #postalDesignation="ngModel" name="postalDesignation"
               messageFieldType="string" disabled>

        <validation-message [control]="postalDesignation"></validation-message>
      </div>
    </div>
  </div>

  <!--Localidade-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('locality') || isNotStateRLDiferido()">
        <label for="locality"  [class.disabled]="isFieldDisabled('locality') || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!isNotStateRLDiferido()">*</span>
          {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Locality' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="cardData.locality"
                 #locality="ngModel" name="locality"
                 [required]="!isNotStateRLDiferido()" messageFieldType="string" style='text-transform:uppercase'>

          <validation-message [control]="locality"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>
</div>

<div class="row ">

  <!--Telefone Fixo-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="telephone"  [class.disabled]="isNotStateRLDiferido()">
        {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Telephone' | translate}}
      </label>
      <div class="position-relative">
        <input class="form-control input-right" type="text" [(ngModel)]="cardData.telephone"
               #telephone="ngModel" name="telephone"
               [disabled]="isNotStateRLDiferido()"
               messageFieldType="string" [pattern]="landlinePattern">

        <validation-message [control]="telephone"></validation-message>
      </div>
    </div>
  </div>

  <!--Telemóvel-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('mobileNumber') || isNotStateRLDiferido()">
        <label for="mobilePhone" [class.disabled]=" isFieldDisabled('mobileNumber') || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!isNotStateRLDiferido()">*</span>{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.MobilePhone' | translate}}
          <button type="button"
                  class="btn-icon text-primary icon-help"
                  aria-label="Tooltip com informação"
                  tooltip="{{'Tooltips.CardSubscriberContacts.MobileNumber' | translate}}"></button>
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="cardData.mobileNumber"
                 #mobilePhone="ngModel" name="mobilePhone"
                 [required]="!isNotStateRLDiferido()" messageFieldType="string" [pattern]="mobilePattern">

          <validation-message [control]="mobilePhone"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--E-mail-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset  [disabled]="isFieldDisabled('email') || isStateRLIndeferido()">
        <label for="email" [class.disabled]="isFieldDisabled('email')  || isStateRLIndeferido()">
          <span class="mandatory" *ngIf="!isNotStateRLDiferido()">*</span>{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Email' | translate}}
          <button type="button"
                  class="btn-icon text-primary icon-help"
                  aria-label="Tooltip com informação"
                  tooltip="{{'Tooltips.CardSubscriberContacts.Email' | translate}}"></button>
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="cardData.email"
                 #email="ngModel" name="email" maxlength="60" email pattern="^.+@.+\..+$"
                 
                 placeholder="{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.EmailPlaceholder' | translate}}"
                 [required]="!isNotStateRLDiferido()" messageFieldType="string" >

          <validation-message [control]="email"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>
</div>
